import { z } from 'zod';

export const orgActiveStudentsSchema = z.object({
  type: z.literal('orgActiveStudents'),
  data: z.array(
    z.object({
      // id will be nullish if this is grouped by month or grade
      id: z.string().uuid().optional().nullable(),
      name: z.string(),
      active: z.number().int().nullable(),
      loggedIn: z.number().int().nullable(),
      entitled: z.number().int().nullable(),
    })
  ),
});

export type OrgActiveStudentsResponse = z.infer<typeof orgActiveStudentsSchema>;
